import React from "react";
import { Link } from "react-router-dom";

import AdminShell from "./AdminShell";

const ITEMS = [
  {
    title: "Enrollment Requests",
    description: "Review, edit, approve, or remove enrollment requests.",
    to: "/admin/enrollments",
  },
  {
    title: "Users",
    description: "Search accounts, edit roles, reset progress, and manage access.",
    to: "/admin/users",
  },
  {
    title: "Cohorts",
    description: "Group students by intake and programme.",
    to: "/admin/cohorts",
  },
  {
    title: "Audit Log",
    description: "Inspect administrative actions and record history.",
    to: "/admin/audit-log",
  },
];

export default function AdminHomePage() {
  return (
    <AdminShell title="Administration" subtitle="Central control panel for enrollments, users, cohorts, and audit records.">
      <section className="td-card reveal" style={{ "--delay": ".08s", padding: 20 }}>
        <div
          style={{
            display: "grid",
            gap: 14,
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          }}
        >
          {ITEMS.map((item) => (
            <div
              key={item.to}
              style={{
                border: "1px solid rgba(255,255,255,.08)",
                borderRadius: 18,
                padding: 18,
                background: "rgba(255,255,255,.03)",
                display: "grid",
                gap: 12,
              }}
            >
              <div>
                <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 8 }}>{item.title}</div>
                <div style={{ color: "var(--muted, #b8b3aa)", lineHeight: 1.5 }}>{item.description}</div>
              </div>
              <Link
                to={item.to}
                style={{
                  display: "inline-flex",
                  justifyContent: "center",
                  alignItems: "center",
                  padding: "10px 14px",
                  borderRadius: 999,
                  background: "rgba(201,165,106,.18)",
                  border: "1px solid rgba(201,165,106,.28)",
                  color: "#fff",
                  textDecoration: "none",
                  fontWeight: 700,
                }}
              >
                Open {item.title}
              </Link>
            </div>
          ))}
        </div>
      </section>
    </AdminShell>
  );
}
